import { DEFAULT_USER_FEEDBACK_SETTINGS } from "src/components";
import { useSettings, type IUserFeedbackSettings } from "src/hooks";

const useUserFeedbackSettings = (userGuid: string) => {
  const {
    userFeedbackSettings: { [userGuid]: unsafeSettings },
    updateUserFeedbackSettings,
  } = useSettings();

  const safeSettings: IUserFeedbackSettings = {
    ...DEFAULT_USER_FEEDBACK_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IUserFeedbackSettings>) => {
      updateUserFeedbackSettings(userGuid, updatedSettings);
    },
  };
};

export { useUserFeedbackSettings };
